<template>
    <div class="bg-white pt-4 pb-4 mt-4">
        <div class="container booking-container">
            <div v-if="isLoaded" class="row">
                <div class="col-sm-12 mb-2">
                    <router-link to="/" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" class="text-primary">
                            <i class="fa fa-arrow-left mr-2"></i> Return to profile
                        </a>
                    </router-link>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <div class="">
                        <h2 class="display-3 montserrat-bold mb-0" v-text="title"></h2>
                        <div class="mt--2 mb-4 heading-small">Announcement</div>

                        <div class="mt-3 mb-4 blockquote" v-text="content"></div>
                        <div class="mt-3 mb-4 blockquote-footer">Cutiefy Administrator</div>
                    </div>      
                </div>
                <div class="col-lg-6 col-sm-12">
                    <img :src="displayImage" class="announcement-image">
                </div>
                
            </div>
            <div v-else class="row">
                <div class="col-sm-12 mb-2">
                    <router-link to="/" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" class="text-primary">
                            <i class="fa fa-arrow-left mr-2"></i> Return to profile
                        </a>
                    </router-link>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <div class="">
                        <h2 class="display-3 montserrat-bold mb-0 ">Loading...</h2>
                        <div class="mt--2 mb-4 heading-small">Announcement</div>

                        <div class="mt-3 mb-4 text-muted">Loading announcement content...</div>
                    </div>      
                </div>
                <div class="col-lg-6 col-sm-12">
                    <img src="/images/placeholders/image.jpg" class="announcement-image-placeholder">
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { route, get } from "@utils/network";
import mixins from "@utils/mixins";

export default {
    name: "AnnouncementPage",

    computed: {
        title() {
            return this.announcement.title;
        },
        content() {
            return this.announcement.content || "";
        },
        displayImage() {
            return this.announcement.display_image;
        },
        isLoaded() {
            return this.announcement.id;
        }
    },

    data: () => ({
        announcement: {},
    }),

    methods: {
        initializeAnnouncement() {
            get(route("announcements/:id", { id: this.$route.params.id }))
                .then(response => this.announcement = response.data.result.announcement)
                .catch(error => this.presentError(error, "Please reload the page"))
        },

        
    },

    mixins: [mixins],

    mounted() {
        this.initializeAnnouncement();
    }
};
</script>
<style scoped>
.announcement-image {
    margin: 0px auto;
    width: 100%;
}
.announcement-image-placeholder {
    filter: blur(10px);
    width: 100%;
}
</style>